// src/pages/personal/analytics/CustomerPage.tsx
import React from 'react';
import { AdaptiveLayout } from '@/components/ui/Layout';
import CustomerSection from './CustomerSection/CustomerSection';

const CustomerPage: React.FC = () => {
  return (
    <AdaptiveLayout>
      <CustomerSection />
    </AdaptiveLayout>
  );
};

export default CustomerPage;